let _currentSearchSuggestion: string | null = null;

export function getCurrentSearchSuggestion() {
  return _currentSearchSuggestion;
}

export function setCurrentSearchSuggestion(searchSuggestion: string) {
  _currentSearchSuggestion = searchSuggestion;
}
